module.exports = __webpack_public_path__ + "img/JabberLogo1.fbcaff7e.svg";